import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "infographics-container" }
const _hoisted_3 = { class: "infographics-header-block text-center" }
const _hoisted_4 = { class: "infographics-logo" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h1", null, "CONVORALLY", -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "step-tab" }
const _hoisted_8 = { class: "step-content" }
const _hoisted_9 = { class: "box-container scrollable" }
const _hoisted_10 = { class: "logout-heading text-center" }
const _hoisted_11 = { class: "uppercase-text" }
const _hoisted_12 = { class: "logout-wrap" }
const _hoisted_13 = { class: "logout-content" }
const _hoisted_14 = { class: "logout-text align-self-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = { class: "to-upper" }
const _hoisted_19 = { class: "log-button text-center " }
const _hoisted_20 = { class: "uppercase-text" }
const _hoisted_21 = { class: "step-move" }
const _hoisted_22 = { class: "step-prev" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "step-next disabled" }, [
  /*#__PURE__*/_createVNode("a", { href: "#" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" })
  ])
], -1)
const _hoisted_25 = { class: "final-container" }
const _hoisted_26 = { class: "final-block" }
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "final-wrap" }
const _hoisted_29 = { class: "convorally-moto" }
const _hoisted_30 = { class: "italic" }
const _hoisted_31 = { class: "final-img-wrap" }
const _hoisted_32 = /*#__PURE__*/_createVNode("p", null, "www. ", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, ".com", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_P = _resolveComponent("P")
  const _component_TutorialStep = _resolveComponent("TutorialStep")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("section", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convoicon-blue.png`: 'timg/convoicon-blue.png' ,
            alt: ""
          }, null, 8, ["src"])
        ]),
        _hoisted_5,
        _createVNode("h2", null, _toDisplayString(_ctx.$t('project_manager_app')), 1),
        _createVNode(_component_P, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('project_manager_description')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_TutorialStep)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/logout.png`: 'timg/logout.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('logout')), 1)
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('tap_on_your_user')) + " ", 1),
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('profile_at_the_top')) + " ", 1),
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('right_corner_to_access')) + " ", 1),
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('the')) + " ", 1),
                    _createVNode("strong", _hoisted_18, "“" + _toDisplayString(_ctx.$t('logout')) + "”", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('button')) + ".", 1)
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("button", _hoisted_20, _toDisplayString(_ctx.$t('logout')), 1),
                  _createVNode("img", {
                    src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/hand-pointer.png`: 'timg/hand-pointer.png' ,
                    alt: ""
                  }, null, 8, ["src"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToStep8 && _ctx.redirectToStep8(...args)))
              }, [
                _hoisted_23
              ])
            ]),
            _hoisted_24
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_25, [
      _createVNode("section", _hoisted_26, [
        _createVNode("div", _hoisted_27, [
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/comment.png`: 'timg/comment.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _createVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('building_confidence_trust')) + " – ", 1),
                _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('one_convo_at_a_time')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_31, [
              _hoisted_32,
              _createVNode("img", {
                src: _ctx.state.data.imageBaseUrl? `${_ctx.state.data.imageBaseUrl}timg/convorally-text.png`: 'timg/convorally-text.png' ,
                alt: ""
              }, null, 8, ["src"]),
              _hoisted_33
            ])
          ])
        ])
      ])
    ])
  ]))
}